"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ID;
var React = _interopRequireWildcard(require("react"));
var _internal = require("@aws-amplify/ui-react/internal");
var _uiReact = require("@aws-amplify/ui-react");
var _excluded = ["overrides"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ID(props) {
  var overrides = props.overrides,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(_uiReact.View, _extends({
    width: "24px",
    height: "24px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    overflow: "hidden",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "ID"), rest), /*#__PURE__*/React.createElement(_uiReact.View, _extends({
    width: "24px",
    height: "24px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    position: "absolute",
    top: "0px",
    bottom: "0px",
    left: "0px",
    right: "0px",
    border: "0px SOLID rgba(112,112,112,1)",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Rectangle 7894"))), /*#__PURE__*/React.createElement(_uiReact.Icon, _extends({
    width: "22px",
    height: "22px",
    viewBox: {
      minX: 0,
      minY: 0,
      width: 22,
      height: 22
    },
    paths: [{
      d: "M11.0049 10.5686C10.4356 10.5686 9.97367 11.0301 9.97367 11.5999C10.0226 14.7043 9.6239 17.6971 8.78342 20.6899C8.66612 21.1076 8.8758 22 9.77686 22C10.2272 22 10.641 21.7027 10.769 21.2472C11.3504 19.1886 12.1028 15.8585 12.0358 11.5999C12.0362 11.0305 11.5747 10.5686 11.0049 10.5686ZM10.9678 7.05666C8.3355 7.05364 6.49856 9.0792 6.53508 11.4004C6.5673 13.4603 6.37395 15.5215 5.96059 17.5256C5.845 18.0833 6.20422 18.6294 6.76153 18.7442C7.32228 18.8589 7.86455 18.501 7.98014 17.9432C8.42444 15.7909 8.63199 13.5785 8.59761 11.3681C8.57999 10.2531 9.45356 9.11271 10.9373 9.11917C12.2826 9.13936 13.393 10.208 13.4132 11.5026C13.4463 13.5673 13.2924 15.6418 12.9573 17.6708C12.864 18.232 13.2447 18.7631 13.8063 18.8559C14.6644 18.999 14.9583 18.2071 14.9914 18.0064C15.3472 15.8567 15.5096 13.6575 15.4757 11.4704C15.4379 9.07275 13.4157 7.09274 10.9678 7.05664L10.9678 7.05666ZM6.21169 6.20677C5.7691 5.84842 5.12156 5.91459 4.76105 6.35631C3.66018 7.70982 3.06849 9.41913 3.09599 11.1688C3.12133 12.7836 2.98985 14.4031 2.70455 15.9835C2.604 16.5442 2.97569 17.0805 3.53643 17.1819C4.40054 17.3323 4.6996 16.5455 4.73484 16.35C5.0438 14.6381 5.18602 12.8841 5.15852 11.1366C5.13833 9.85268 5.55384 8.64955 6.36166 7.65741C6.72046 7.21569 6.65342 6.56643 6.2117 6.20679L6.21169 6.20677ZM10.9156 3.52854C10.2534 3.51092 9.58914 3.59041 8.94846 3.7421C8.39458 3.87358 8.05169 4.42873 8.18231 4.98346C8.31379 5.53733 8.86982 5.8785 9.42369 5.7496C9.8985 5.63745 10.3892 5.58761 10.8846 5.59105C14.1258 5.6396 16.8028 8.23363 16.8522 11.3738C16.8776 13.0014 16.7972 14.6441 16.6124 16.2563C16.548 16.8222 16.954 17.334 17.5195 17.3985C18.238 17.4822 18.6157 16.888 18.6616 16.4914C18.8569 14.782 18.9414 13.0618 18.9147 11.3416C18.8477 7.0984 15.2593 3.59301 10.9156 3.52856L10.9156 3.52854ZM21.7467 8.74716C21.6239 8.192 21.0803 7.83622 20.5174 7.96211C19.9614 8.085 19.6099 8.63501 19.7328 9.19145C19.9352 10.1114 19.9438 10.7989 19.9347 11.8383C19.93 12.4085 20.3881 12.8735 20.9574 12.8782L20.966 12.8782C21.5319 12.8782 21.9925 12.4223 21.9973 11.8555C22.005 10.9025 22.0145 9.96016 21.7467 8.74716ZM20.0228 4.84902C17.9302 1.86741 14.506 0.0554239 10.8627 0.000856855C7.86384 -0.0352438 5.09017 1.07036 3.02721 3.13414C1.03473 5.12917 -0.0390689 7.77906 0.00560588 10.5983L0.000455318 11.5208C-0.0162997 12.0901 0.431438 12.5654 1.00078 12.5817C1.01066 12.5825 1.0214 12.5825 1.03171 12.5825C1.58687 12.5825 2.04535 12.14 2.06168 11.5814L2.06856 10.5656C2.0329 8.30974 2.89185 6.1888 4.48688 4.59292C6.15236 2.92573 8.41168 2.02898 10.8326 2.06378C13.8168 2.10803 16.6218 3.59175 18.3359 6.03367C18.6629 6.50031 19.3053 6.61159 19.7719 6.28546C20.2377 5.95804 20.3503 5.3148 20.0228 4.84902Z",
      fill: "rgba(92,102,112,1)",
      fillRule: "evenodd"
    }],
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    position: "absolute",
    top: "1px",
    bottom: "1px",
    left: "1px",
    right: "1px"
  }, (0, _internal.getOverrideProps)(overrides, "fingerprint-solid")), /*#__PURE__*/React.createElement(_uiReact.Icon, _extends({
    width: "3.29px",
    height: "11.43px",
    viewBox: {
      minX: 0,
      minY: 0,
      width: 3.2861328125,
      height: 11.431396484375
    },
    paths: [],
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    position: "absolute",
    top: "44.04%",
    bottom: "8.33%",
    left: "36.47%",
    right: "49.83%"
  }, (0, _internal.getOverrideProps)(overrides, "61FA09D0-3679-4767-807B-FF92A0D47504"))), /*#__PURE__*/React.createElement(_uiReact.Icon, _extends({
    width: "9.54px",
    height: "11.82px",
    viewBox: {
      minX: 0,
      minY: 0,
      width: 9.541015625,
      height: 11.81640625
    },
    paths: [],
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    position: "absolute",
    top: "29.4%",
    bottom: "21.36%",
    left: "24.75%",
    right: "35.5%"
  }, (0, _internal.getOverrideProps)(overrides, "59C09843-55C4-4DB0-9A6C-30939DC4038A"))), /*#__PURE__*/React.createElement(_uiReact.Icon, _extends({
    width: "3.9px",
    height: "11.22px",
    viewBox: {
      minX: 0,
      minY: 0,
      width: 3.904296875,
      height: 11.224853515625
    },
    paths: [],
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    position: "absolute",
    top: "24.9%",
    bottom: "28.33%",
    left: "11.2%",
    right: "72.53%"
  }, (0, _internal.getOverrideProps)(overrides, "5A121C3F-A625-4709-95B6-5AD1A16B886C"))), /*#__PURE__*/React.createElement(_uiReact.Icon, _extends({
    width: "10.76px",
    height: "13.88px",
    viewBox: {
      minX: 0,
      minY: 0,
      width: 10.76513671875,
      height: 13.88037109375
    },
    paths: [],
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    position: "absolute",
    top: "14.69%",
    bottom: "27.47%",
    left: "33.98%",
    right: "21.17%"
  }, (0, _internal.getOverrideProps)(overrides, "3F2F9CAF-7F0B-4C5D-97C7-B83D03551651"))), /*#__PURE__*/React.createElement(_uiReact.Icon, _extends({
    width: "2.29px",
    height: "4.94px",
    viewBox: {
      minX: 0,
      minY: 0,
      width: 2.29150390625,
      height: 4.94140625
    },
    paths: [],
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    position: "absolute",
    top: "33.07%",
    bottom: "46.34%",
    left: "82.12%",
    right: "8.33%"
  }, (0, _internal.getOverrideProps)(overrides, "2D8AA99B-CEC4-4778-A23B-AFBC89924483"))), /*#__PURE__*/React.createElement(_uiReact.Icon, _extends({
    width: "20.21px",
    height: "12.58px",
    viewBox: {
      minX: 0,
      minY: 0,
      width: 20.21044921875,
      height: 12.58251953125
    },
    paths: [],
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    position: "absolute",
    top: "0%",
    bottom: "47.57%",
    left: "0%",
    right: "15.79%"
  }, (0, _internal.getOverrideProps)(overrides, "6C1D2CFB-C848-4085-8E85-CDE7166AE93A")))));
}